import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";

import './App.css';
import './BalooBhaiFontFamily.css';

import AdminContext from './Context/adminContext';
import GuestContext from './Context/guestContext';
import NotRegistered from './Pages/NotRegistered/NotRegistered';
import AppRoutes from './routing/AppRoutes';
import AccessDeniedModal from './Components/AccessDeniedModal/AccessDeniedModal';
import useAccessControl from './hooks/useAccessControl';
import useLastAllowedPath from './hooks/useLastAllowedPath';
import useNavigationGuards from './hooks/useNavigationGuards';

function App() {
    const API_URL = process.env.REACT_APP_API_URL;
    const { accounts } = useMsal();
    const account = accounts[0];
    const navigate = useNavigate();

    const [count, setCount] = useState(0);
    const [increase, setIncrease] = useState(1);

    useEffect(() => {
        const handleClick = (event) => {
            if (event.ctrlKey && event.button === 0) {
                setCount((prevCount) => prevCount + increase);
                setIncrease(increase + increase)
            }
        };

        window.addEventListener('click', handleClick);

        return () => {
            window.removeEventListener('click', handleClick);
        };
    }, []);


    const fallbackAllowedPath = '/Profile/Leave';

    const {
        isAdmin,
        isGuest,
        guestAllowedPages,
        userAllowedPages,
        guestExists,
        hasAccessEnabled,
        accessLoaded,
        allowedPrefixes,
    } = useAccessControl({ account, API_URL });

    const {
        showAccessDenied,
        setShowAccessDenied,
        lastDeniedPath,
        lastAllowedPath,
        getFullPath,
        handleDenied,
        shouldRedirectOnDenied,
    } = useLastAllowedPath({
        allowedPrefixes,
        accessLoaded,
        guestAllowedPages,
        userAllowedPages,
        hasAccessEnabled,
        isAdmin,
        fallbackAllowedPath,
    });

    useNavigationGuards({
        allowedPrefixes,
        accessLoaded,
        lastAllowedPath,
        lastDeniedPath,
        fallbackAllowedPath,
        getFullPath,
        onDenied: handleDenied,
        shouldRedirectOnDenied,
    });
    return (
        <GuestContext.Provider value={{ isGuest, allowedPages: ((Array.isArray(guestAllowedPages) && guestAllowedPages.length>0) ? guestAllowedPages : (userAllowedPages || [])), exists: guestExists }}>
            <AdminContext.Provider value={isAdmin}>
                {guestExists ? (
                    <>
                        <AppRoutes
                            isAdmin={isAdmin}
                            accessLoaded={accessLoaded}
                            allowedPrefixes={allowedPrefixes}
                            lastDeniedPath={lastDeniedPath}
                            onDenied={handleDenied}
                            lastAllowedPath={lastAllowedPath}
                            shouldRedirectOnDenied={shouldRedirectOnDenied}
                            fallbackAllowedPath={fallbackAllowedPath}
                        />
                        <AccessDeniedModal
                            open={showAccessDenied}
                            onClose={() => setShowAccessDenied(false)}
                            allowedPrefixes={allowedPrefixes}
                            lastAllowedPath={lastAllowedPath}
                            fallbackAllowedPath={fallbackAllowedPath}
                            shouldRedirectOnDenied={shouldRedirectOnDenied}
                            navigate={navigate}
                            getFullPath={getFullPath}
                        />
                    </>
                ) : (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
                        <NotRegistered />
                    </div>
                )}
            </AdminContext.Provider>
        </GuestContext.Provider>
    );
}


export default App;

